<template>
    <header class="l-header" v-bind:class="openMenuButton">
        <router-link tag="div" class="l-header__logo-wrap"
                     :to="{name: 'Index',params: {lang: this.$route.params.lang}}">
            <img class="l-header__logo" src="@/assets/svg/logo_micro.svg" alt="Micro - займы">
        </router-link>

        <div class="l-header__menu-hamburger menu-hamburger" v-bind:class="openMenuButton" v-on:click="openMenu">
            <span class="menu-hamburger__stick"></span>
            <span class="menu-hamburger__stick"></span>
            <span class="menu-hamburger__stick"></span>
            <span class="menu-hamburger__stick"></span>
        </div>

        <nav class="l-header__menu" v-bind:class="openMenuList">
            <ul class="l-header__menu-list">
                <router-link class="l-header__menu-item" tag="li" @click.native="openMenu"
                             :to="{name: 'Index', params: {lang: this.$route.params.lang} }">
                    <a>О продуктах</a>
                </router-link>
                <router-link class="l-header__menu-item" tag="li" @click.native="openMenu"
                             :to="{name: 'Micro', params: {lang: this.$route.params.lang} }">
                    <a>Микрокредит</a>
                </router-link>
                <router-link class="l-header__menu-item" tag="li" @click.native="openMenu"
                             :to="{name: 'Business', params: {lang: this.$route.params.lang} }">
                    <a>Бизнес кредит</a>
                </router-link>
                <router-link class="l-header__menu-item" tag="li" @click.native="openMenu"
                             :to="{name: 'How_to_get', params: {lang: this.$route.params.lang} }">
                    <a>Как получить</a>
                </router-link>
                <router-link class="l-header__menu-item" tag="li" @click.native="openMenu"
                             :to="{name: 'How_to_pay_off', params: {lang: this.$route.params.lang} }">
                    <a>Как погасить</a>
                </router-link>
                <!--<router-link class="l-header__menu-item" tag="li" @click.native="openMenu"
                             :to="{name: 'Contacts' , params: {lang: this.$route.params.lang}}">
                    <a>Контакты</a>
                </router-link>-->
            </ul>
            <div class="l-header__cabinet-wrap">
                <router-link class="l-header__cabinet-button" tag="a" @click.native="openMenu" :to="{name: 'Login', params: {lang: this.$route.params.lang}}">Личный кабинет
                </router-link>
            </div>

        </nav>
        <progress-bar></progress-bar>
    </header>
</template>

<script>
  import widthMixin from '@/modules/mixins/widthMixin'

export default {
  mixins: [widthMixin],
  name: "l-Header",
  data() {
    return {
            openMenuStatus: false
    };
  },
  methods: {
    openMenu() {
      if( !this.isDesktop ){
        this.openMenuStatus = !this.openMenuStatus;
      }
    }
  },
  computed: {
    openMenuButton() {
      return { open: this.openMenuStatus };
    },
    openMenuList() {
      return { "l-header__menu--open": this.openMenuStatus };
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.l-header {
  $blockname: &;
  max-width: 1034px;
  margin: 0 auto;
  padding: 25px 25px;
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-flow: row wrap;
  &__logo-wrap {
    display: block;
    position: relative;
    z-index: 1015;
    width: 130px;
  }
  &__logo {
    max-width: 130px;
    width: 100%;
  }
  &__menu {
    display: flex;
    justify-content: space-between;
    flex: 1;
  }
  &__menu-list {
    list-style: none;
    display: flex;
    margin-top: 5px;
    flex: 1;
    padding: 0 20px;
    justify-content: flex-start;
    align-items: center;
  }
  &__menu.l-header__menu--open{
      .l-header__menu-item.router-link-exact-active{
          padding: 10px 5px;
          border-bottom: 0;
      }
  }
  &__menu-item:not(:first-child).router-link-active,
  &__menu-item.router-link-exact-active {
    border-bottom: 3px solid $violet;
    padding-bottom: 2px;
  }
  &__menu-item {
    padding: 2px 0 5px;
    margin: 0 6px;
    a {
      font-size: 15px;
      color: $black;
      font-family: $RobotoRegular;
      text-decoration: none;
      vertical-align: top;
    }
  }
  &__cabinet-wrap {
    margin-top: 5px;
  }
  &__cabinet-button {
    text-decoration: none;
    color: $gray-dim-dark;
    font-size: 18px;
    line-height: 18px;
    padding: 7px 18px 10px;
    background: $yellow-1;
    text-align: center;
    font-family: $RobotoRegular;
    font-weight: normal;
    display: inline-block;
    box-sizing: border-box;
    border-radius: 25px;
  }
  &__menu-hamburger {
    display: none;
  }
  &__mobile-footer {
    display: none;
  }
}
.menu-hamburger {
  $blockname: &;
  width: 25px;
  height: 43px;
  position: relative;
  margin: 5px 0;
  transition: 0.5s ease-in-out;
  cursor: pointer;
  &__stick {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: $violet;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    &:nth-child(1) {
      top: 0;
    }
    &:nth-child(2),
    &:nth-child(3) {
      top: 8px;
    }
    &:nth-child(4) {
      top: 16px;
    }
  }

  &.open {
    #{$blockname}__stick:nth-child(1) {
      top: 8px;
      width: 0;
      left: 50%;
    }
    #{$blockname}__stick:nth-child(2) {
      transform: rotate(45deg);
    }
    #{$blockname}__stick:nth-child(3) {
      transform: rotate(-45deg);
    }
    #{$blockname}__stick:nth-child(4) {
      top: 8px;
      width: 0;
      left: 50%;
    }
  }
}
@media screen and (max-width: 1024px) {
  .l-header {
    justify-content: space-between;
    display: flex;
    padding: 10px 15px;
      position: fixed;
      width: 100%;
      top: 0;
      max-width: 100%;
      z-index: 1001;
      background: $white;
      border-bottom: 1px solid $gray;
    &.open{
        &:after{
            content: '';
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            background: $white;
            width: 100%;
            height: 48px;
            z-index: 1012;
            border-bottom: 1px solid $gray;
        }
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        background: $white;
        z-index: 1001;
    }
    &__menu-hamburger {
      position: relative;
      z-index: 1015;
      display: block;
      margin: 5px 0;
      height: 18px;
      order: 4;
    }
    &__menu {
      position: fixed;
        overflow-y: scroll;
      background: $white;
      width: 100%;
      left: 0;
      z-index: 1009;
      top: -100%;
        transform: translateY(-100%);
      transition: 0.7s ease all;
      flex-direction: column;
      align-items: flex-start;
      order: 2;
    }
    &__logo-wrap {
      order: 1;
    }
    .progress-bar {
      width: 60vw;
      order: 3;
    }
    &__menu--open {
      transition: 0.3s ease all;
      pointer-events: auto;
        overflow-y: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        padding-top: 48px;
        height: auto;
        transform: translateY(0);
      padding-bottom: 20px;
    }
    &__menu-list {
        order: 2;
        max-width: 100%;
        width: 100%;

        max-height: 100%;
        height: 100%;
        min-height: 290px;
        flex: 1;


        padding: 0 10px;
        text-align: left;
        flex-direction: column;
        align-items: flex-start;
    }
    &__menu-item {
      text-align: left;
      margin: 0;
      width: 100%;
      max-width: 100%;
      padding: 10px 5px;
      border-top: 1px solid $gray;
      a {
        width: 100%;
        display: inline-block;
          font-size: 18px;
          font-family: $RobotoRegular;
      }
      &:first-child {
        border-top: none;
      }
      &:last-child {
        border-bottom: 1px solid $gray;
      }
    }
    &__menu-item.router-link-exact-active {
      border-top: 1px solid $gray;
      padding: 10px 5px;
      border-bottom: none;
      background: rgba(#93278f, 0.08);
      /*background: rgba(147, 39, 143, 0.8);*/
      &:first-child{
          padding-top: 9px;
          border-top: 1px solid $gray;
      }
      &:last-child{
          padding-bottom: 9px;
          border-bottom: 1px solid $gray;
      }
      a {
        color: $violet;
      }
      & + .l-header__menu-item {
        border-top: 1px solid $gray;
      }
    }

    &__cabinet-wrap {
      order: 1;
      padding: 20px 15px;
    }
    &__cabinet-button {
      text-decoration: underline;
      color: $yellow-1;
      font-size: 18px;
      line-height: 18px;
      padding: 0;
      background: none;
      text-align: center;
      font-family: $RobotoRegular;
      font-weight: normal;
      display: inline-block;
      box-sizing: border-box;
      border-radius: 25px;
    }
    &__mobile-footer {
      display: block;
      justify-self: flex-end;
      text-align: center;
      align-self: center;
      order: 3;
    }
    &__social-icons {
      display: flex;
      margin: 10px 0;
      justify-content: center;
      list-style-type: none;
    }
    &__social-icon {
      margin: 0 5px;
      img {
        max-width: 30px;
        max-height: 30px;
        width: 100%;
        height: 100%;
      }
    }
    &__copyright {
      color: $gray-dim;
      font-size: 14px;
      font-family: $RobotoRegular;
    }
  }
}
@media screen and (max-width: 768px) {
    .l-header {
        /*&__logo-wrap {
            display: none;
        }*/
        .progress-bar {
            width: 80vw;
            margin: 0;
            order: 1;
            &__status {
                margin: 10px 0 0;
            }
        }
    }
}
</style>
